import SeparateLine from '../../../Common/seperateLine';
const SectionHeader = props => {
  return (
    <>
      <div style={{"backgroundColor": "#eaeaea", "height": "26px"}}>
        <div className="float-left pl-1 pt-1" style={{ color: '#075978' }}>
          <b>{props.title}</b>
        </div>
        <div className="float-right">{props.headerComponent}</div>
      </div>
      <SeparateLine className="underLine" />
    </>
  );
};

export default SectionHeader;
